// VOLTWAYZ storefront enhancements (custom - added by assistant)
(function(){
  if (window.__vwEnh) return; window.__vwEnh = true;

  // --- Kill the "weird zoom" on product cards -------------------------------
  // The December theme adds class "scale-in" (hover zoom) to the card image and
  // swaps in a 'second-image' on hover. Both make cards jump/zoom oddly.
  function injectCardCss(){
    if (document.getElementById('vw-card-css')) return;
    var s = document.createElement('style');
    s.id = 'vw-card-css';
    s.textContent = [
      '.product-card__image img, .product-card__image .scale-in {',
      '  transition: none !important;',
      '}',
      '.product-card__image:hover img, .product-card__image:hover .scale-in,',
      '.product-card:hover .product-card__image img, .product-card:hover .scale-in {',
      '  transform: none !important;',
      '  scale: 1 !important;',
      '}',
      '.product-card__image .second-image, .product-card__image img.second-image,',
      '.product-card .second-image {',
      '  opacity: 0 !important;',
      '  display: none !important;',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);
  }
  injectCardCss();

  // Fix oversized hardcoded banner headlines on mobile (inline 55px clips on phones)
  function fixBanners(){
    var mobile = window.innerWidth <= 749;
    var hs = document.querySelectorAll('.grid-banner h2, .banner h2, [class*="banner"] h2');
    [].forEach.call(hs, function(h){
      if (!h.hasAttribute('data-vwfs')) h.setAttribute('data-vwfs', h.style.fontSize || '');
      var orig = h.getAttribute('data-vwfs');
      var size = parseInt(orig, 10);
      if (!(size >= 40)) return;
      if (mobile){
        h.style.setProperty('font-size', 'clamp(17px, 5.4vw, 30px)', 'important');
        h.style.setProperty('line-height', '1.1', 'important');
        h.style.setProperty('letter-spacing', '0', 'important');
        h.style.setProperty('overflow-wrap', 'break-word', 'important');
        h.style.setProperty('max-width', '100%', 'important');
      } else {
        h.style.setProperty('font-size', orig, 'important');
        h.style.removeProperty('line-height');
        h.style.removeProperty('overflow-wrap');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixBanners);
  else fixBanners();
  window.addEventListener('resize', fixBanners);
  setTimeout(fixBanners, 900);
})();